import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    alertCard: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flex: 1,
        ...webStyle({
            transition: "all 0.2s ease-in-out",
            cursor: "pointer"
        })
    },
    alertIconWrapper: {
        justifyContent: "center",
        alignItems: "center"
    },
    alertTextWrapper: {
        flexDirection: "column",
        flex: 1
    },
    container: {
        flexDirection: "column"
    },
    bannerGrid: {
        alignItems: "stretch",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    headerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    alertContent: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    }
});
export default stylesheet;
